module.exports = "<h1>Editor</h1> <div data-bind=\"component: { name: 'widget-page', params: { widget: widget } }\"></div> ";